export class CoreBenefitResponse {
    totalItems: number;
	benefitCategories: CoreBenefitMultiple[];

	constructor() {
        this.totalItems = 0;
		this.benefitCategories = new Array<CoreBenefitMultiple>();
	}
}

export class CoreBenefitMultiple {
	categoryID: number;
	categoryName: string;
	materialIconName: string;
	items: CoreBenefit[];

	constructor() {
		this.categoryID = 0;
		this.categoryName = '';
		this.materialIconName = '';
		this.items = [];
	}
}

export class CoreBenefitCounter {
	categoryID: number;
	count: number;

	constructor() {
		this.categoryID = 0;
		this.count = 0;
	}
}

export class CoreBenefit {
	uniqueID: string;
	enrollmentName: string;
	isSelected: boolean;
	isRequired: boolean;

	constructor() {
		this.uniqueID = '';
		this.enrollmentName = '';
		this.isSelected = false;
		this.isRequired = false;
	}
}

export class CoreBenefitPayload {
	uniqueIDs: string[];

	constructor() {
		this.uniqueIDs = [];
	}
}

export class CoreBenefitCategory {
	categoryID: number;
	currentSelection: CoreBenefit[];
	indices: CoreBenefit[];
	lastSelection: CoreBenefit;
	uniqueIDs: string[];

	constructor() {
		this.categoryID = 0;
		this.currentSelection = [];
		this.indices = [];
		this.lastSelection = null;
		this.uniqueIDs = [];
	}
}

export class AutoTermCoreBenefit extends CoreBenefit {
	availableOn: string;
	unavailableOn: string;
	terminationDate: string;
	enrollmentName: string;
	isRequired: boolean;
	isSelected: boolean;
	uniqueID: string;

	constructor() {
		super();
		this.availableOn = null;
		this.unavailableOn  = null;
		this.terminationDate = null;
		this.enrollmentName = null;
		this.isRequired = false;
		this.isSelected = false;
		this.uniqueID = null;
	}
}

export class AutoTermResponse {
	items: AutoTermCoreBenefit[];
	pageSize: number;
	totalItems: number;
	totalPages: number;

	constructor() {
		this.items = new Array<AutoTermCoreBenefit>();
		this.pageSize = 0;
		this.totalItems = 0;
		this.totalPages = 0;
	}
}
